import BeautyInsiderBenefits from 'components/Content/BeautyInsider/BeautyInsiderBenefits/BeautyInsiderBenefits';

export default BeautyInsiderBenefits;
